import { render, staticRenderFns } from "./variation-settings.vue?vue&type=template&id=c9a6c9a6&"
import script from "./variation-settings.vue?vue&type=script&lang=js&"
export * from "./variation-settings.vue?vue&type=script&lang=js&"
import style0 from "./variation-settings.vue?vue&type=style&index=0&id=c9a6c9a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports